import { produce } from 'immer'
import { Reducer } from 'redux'

import { SET_FACETS_PAGINATION_MODE } from 'redux/actions/types'

interface FacetsState {
  paginationMode: string
}

const initialState: FacetsState = {
  paginationMode: ''
}

const facets: Reducer<FacetsState, any> = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_FACETS_PAGINATION_MODE:
      return produce(state, draft => {
        draft.paginationMode = action.paginationMode
      })
    default:
      return state
  }
}

export default facets
